import { create } from 'zustand';
import { persist } from 'zustand/middleware';

function getSystemMode() {
  if (typeof window === 'undefined') return 'light';
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

function resolveMode(preference) {
  if (preference === 'system') return getSystemMode();
  return preference;
}

const useThemeStore = create(
  persist(
    (set) => ({
      preference: 'system', // 'system' | 'light' | 'dark'
      hasHydrated: false,
      setPreference: (preference) => set({ preference }),
      cyclePreference: () =>
        set((state) => {
          const order = ['system', 'light', 'dark'];
          const next = order[(order.indexOf(state.preference) + 1) % order.length];
          return { preference: next };
        }),
      setHasHydrated: (hasHydrated) => set({ hasHydrated }),
    }),
    {
      name: 'theme-preference',
      partialize: (state) => ({ preference: state.preference }),
      onRehydrateStorage: () => (state) => {
        state?.setHasHydrated(true);
      },
    }
  )
);

export { resolveMode };
export default useThemeStore;
